// extracted by mini-css-extract-plugin
export default {"item":"DiceStyleSelector_item__ZCNKw"};